import '@root/images';
import '@root/initializers/full_story';
import '@root/initializers/gtm';
import '@root/initializers/impact';
import '@root/initializers/new_relic';
import '@root/initializers/sentry';
import { trackPageview } from '@root/initializers/wt';

trackPageview();
